module.exports = __webpack_public_path__ + "static/media/barcode-graphic.68b05423.svg";